export default "__VITE_ASSET__cd528012__"